export const SET_CURRENT_TRACK = 'SET_CURRENT_TRACK'
export const SET_PLAYER_STATUS = 'SET_PLAYER_STATUS'
export const DO_SET_TRACK = 'DO_SET_TRACK'
export const DO_SET_PLAYER_STATUS = 'DO_SET_PLAYER_STATUS'
export const SET_CURRENT_VIDEO = 'SET_CURRENT_VIDEO'
export const SET_VIDEO_STATUS = 'SET_VIDEO_STATUS'
export const DO_SET_VIDEO = 'DO_SET_VIDEO'
export const DO_SET_VIDEO_STATUS = 'DO_SET_VIDEO_STATUS'